module.exports = __webpack_public_path__ + "static/media/gosavemore.ca77d5b0.png";